import { observer } from "mobx-react-lite";
import { useMemo } from "react";

import { useLogSetProgressValue } from "src/workouts/useLogSetProgressValue";
import {
  type WorkoutItemSetProviderProps,
  workoutItemSetContext,
} from "src/workouts/WorkoutItemSetContext.shared";
import { useWorkoutPermissions } from "src/workouts/WorkoutItemsPermission";

export const ReadOnlyWorkoutItemWorkoutSetProvider = observer(
  function ReadOnlyWorkoutItemWorkoutSetProvider(
    props: WorkoutItemSetProviderProps,
  ) {
    const workoutItemsPermissions = useWorkoutPermissions();
    const logSetProgressValue = useLogSetProgressValue();

    const value = useMemo(() => {
      return {
        getType: () => {
          return props.attribute.exerciseAttribute.type;
        },
        updateEditableValue: (value: string) => {
          logSetProgressValue({
            workoutSetId: props.workoutSet.id,
            exerciseAttributeId: props.attribute.exerciseAttributeId,
            trackedValue: value,
          });
        },
        getEditableValue: () => {
          if (!props.attributeValue) {
            return "";
          }

          return props.attributeValue.trackedValue;
        },
        getEditableInputId: () => {
          return `${props.workoutSet.id}:${props.attribute.exerciseAttributeId}:${props.attribute.exerciseAttribute.type}`;
        },
        isEditableInputDisabled: () => {
          return !workoutItemsPermissions.canLogSets;
        },
        renderAssignedValue: () => {
          return null;
        },
      };
    }, [
      props.attributeValue?.assignedValue,
      props.attributeValue?.trackedValue,
      props.attribute.exerciseAttribute.type,
      props.attribute.exerciseAttributeId,
      props.workoutSet.id,
      workoutItemsPermissions.canLogSets,
    ]);

    return (
      <workoutItemSetContext.Provider value={value}>
        {props.children}
      </workoutItemSetContext.Provider>
    );
  },
);
